module.exports = __webpack_public_path__ + "src/assets/img/cinemaad.2c85edb1.jpg";